import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { MarqueeTile, MarqueeType } from '@frontend/sports/types/components/content';

export enum VisibilityOnMarquee {
    MarqueeOnly = 'MarqueeOnly',
    PromotionOnly = 'PromotionOnly',
    All = 'All',
}

export class MarqueeTracking {
    modulePosition: string;
    pageLayout: string;
    moduleCustomName: string;
    marqueeRecommendationType?: string;
    marqueeName?: string;
    sitecoreTemplateId?: string;
}

export interface Tile {
    index: number;
    source: MarqueeTile | null;
    sportId: number;
    fallbackMarketType?: string;
    fixtureId: string;
    event: EventModel;
    marqueeType: MarqueeType;
    showOnHomeLobby: boolean;
    showOnSportsLobby: boolean;
    crmPromotionId?: string;
    crmPromotionVisibility: VisibilityOnMarquee;
    marketType?: string;
    trackingDetail?: MarqueeTracking;
    isFromPortal?: boolean;
    ogpOverlay?: boolean;
    imageUrl?: string;
    isRacingMarquee?: boolean;
    //TODO try to replace native price with Odds
    previousNativePrice?: NativePrice;
}
